import React from 'react';

import cn from 'classnames';
import { t } from 'ttag';

import css from './loading.css';

type LoadingType = 'text' | 'spinner';

interface LoadingProps {
    type?: LoadingType;
    spinnerSize?: number;
    className?: string;
}

const Loading: React.FC<React.PropsWithChildren<LoadingProps>> = ({
    type = 'text',
    className,
    spinnerSize = 50,
}) => (
    <div className={cn(css.root, className)}>
        {type === 'text' && <>{t`Завантажую`}</>}
        {type === 'spinner' && (
            <div
                style={{
                    position: 'relative',
                    width: spinnerSize,
                    height: spinnerSize,
                    display: 'inline-block',
                }}
            >
                <svg className={css.spinner} viewBox="0 0 50 50">
                    <circle
                        className={css.path}
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                    />
                </svg>
            </div>
        )}
    </div>
);

export default Loading;
